import { Workbox } from "workbox-window";

if ("serviceWorker" in navigator) {
    const ua = navigator.userAgent.toLowerCase();
    const isSafari =
        ua.includes("safari") &&
        !ua.includes("chrome") &&
        !ua.includes("android");

    if (isSafari) {
        navigator.serviceWorker.getRegistrations().then((registrations) => {
            registrations.forEach((r) => r.unregister());
            caches
                .keys()
                .then((keys) => keys.forEach((key) => caches.delete(key)));
        });
    } else {
        const wb = new Workbox("/sw.js");

        wb.addEventListener("waiting", () => {
            console.log(
                "A new service worker has installed, but it can't activate" +
                    "until all tabs running the current version have fully unloaded.",
            );
        });
        wb.addEventListener("activated", () => {
            wb.messageSW({
                type: "SKIP_WAITING",
            });
        });
        wb.register().then((reg) => {
            (reg || wb).update();
        });
    }
}
